"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const landingEditor_1 = require("../enums/landingEditor");
function defaultSection() {
    return {
        id: (0, nanoid_1.nanoid)(10),
        type: landingEditor_1.ELEMENT_TYPE.SECTION,
        background: {
            value: '#097158',
        },
        width: '100%',
        height: '50%',
        children: [],
    };
}
exports.default = defaultSection;
